function handleStickyElement(el, positionReferenceEl) {
    try {
        let { simmonsIsBeingSticky, originDistanceFromTop } = el.dataset
        originDistanceFromTop = +originDistanceFromTop
        const { y: referenceDistanceFromTop } = positionReferenceEl.getBoundingClientRect()
        if (referenceDistanceFromTop <= 0) {
            if (simmonsIsBeingSticky === 'true') return
            el.dataset.simmonsIsBeingSticky = 'true'
        } else {
            if (!simmonsIsBeingSticky || simmonsIsBeingSticky === 'false') return
            el.dataset.simmonsIsBeingSticky = 'false'
        }
    } catch (ex) {
        console.error(ex)
    }
}

const stickyElements = document.querySelectorAll(`[data-simmons-is-sticky="true"]`)

stickyElements.forEach(se => {
    const positionReferenceElement = document.querySelector(se.dataset.positionReferenceElementSelector)
    const { top: originDistanceFromTop } = positionReferenceElement.getBoundingClientRect()
    positionReferenceElement.dataset.originDistanceFromTop = originDistanceFromTop
    handleStickyElement(se, positionReferenceElement)
    window.addEventListener('scroll', (event) => {
        handleStickyElement(se, positionReferenceElement)
    })
})

// --------------------------------------

// function handleStickyOnScrollElement(stickyEl, stickyParentEl) {
//     let { originDistanceFromTop } = stickyParentEl.dataset
//     originDistanceFromTop = +originDistanceFromTop
//     const { top: parentDistanceFromTop, height: parentHeight } = stickyParentEl.getBoundingClientRect()
//     const { height: elementHeight } = stickyEl.getBoundingClientRect()
//     console.log({ parentDistanceFromTop, parentHeight, elementHeight, originDistanceFromTop })

//     let targetDistanceFromTop = 0
//     if (parentDistanceFromTop < 0) {
//         targetDistanceFromTop = Math.abs(parentDistanceFromTop)
//         if (parentHeight + parentDistanceFromTop < elementHeight) {
//             targetDistanceFromTop = parentHeight - elementHeight
//         }
//     }
//     stickyEl.style.transform = `translateY(${targetDistanceFromTop}px)`
// }

// const stickyOnScrollElements = document.querySelectorAll(`[data-simmons-sticky-on-scroll]`)

// stickyOnScrollElements.forEach(sse => {
//     const stickyParentEl = document.querySelector(sse.dataset.simmonsStickyParentSelector)
//     const { top: originDistanceFromTop } = stickyParentEl.getBoundingClientRect()
//     stickyParentEl.dataset.originDistanceFromTop = originDistanceFromTop
//     handleStickyOnScrollElement(sse, stickyParentEl)
//     window.addEventListener('scroll', (event) => {
//         handleStickyOnScrollElement(sse, stickyParentEl)
//     })
// })

// --------------------------------------

const mobileBreakpoint = 640

function resizeSkittlesPDPInfo(galleryEl, infoEl) {
    let targetHeight = 'auto'
    if (window.innerWidth < mobileBreakpoint) {
        infoEl.style.height = targetHeight
        return
    }
    targetHeight = galleryEl.clientHeight
    infoEl.style.height = `${targetHeight}px`
}

function handleSkittlesPDP(skittlesPDPcontent) {

    const galleryBox = skittlesPDPcontent.querySelector('.product_images_wrap')
    const infoBox = skittlesPDPcontent.querySelector('.product_data_container')

    let startupResizeInterval, startupResizeIntervalCount = 0
    startupResizeInterval = setInterval(() => {
        if (startupResizeIntervalCount > 20) {
            clearInterval(startupResizeInterval)
            return
        }
        startupResizeIntervalCount++
        resizeSkittlesPDPInfo(galleryBox,infoBox)
    }, 500)
    window.addEventListener('scroll', () => resizeSkittlesPDPInfo(galleryBox, infoBox))
    window.addEventListener('resize', () => resizeSkittlesPDPInfo(galleryBox, infoBox))

}

const skittlesPDPcontent = document.querySelector('.skittles-product-content')
if (skittlesPDPcontent) handleSkittlesPDP(skittlesPDPcontent)

function watchElementScrollState(element) {
    const { scrollTop } = element
    if (scrollTop === 0) {
        element.dataset.scrollThumbAtTop = 'true'
    } else {
        element.dataset.scrollThumbAtTop = 'false'
    }
}

const skittlesProductInfo = document.querySelector('.skittles-product-content .product_data_container')
if (skittlesProductInfo) {
    watchElementScrollState(skittlesProductInfo)
    skittlesProductInfo.addEventListener('scroll', () => {
        watchElementScrollState(skittlesProductInfo)
    })
}

function scrollElBy(el, distance) {
    el.scrollBy({ top: distance, behavior: 'smooth' })
}

function handleParallaxElements(parallaxElements) {

    window.addEventListener('scroll', function(e) {

        for (const el of parallaxElements) {

            const pos = Math.floor(window.pageYOffset * +el.dataset.simmonsParallax);
            let transformValue = el.style.transform || ''

            const translate3dIndex = transformValue.indexOf('translate3d')
            if (translate3dIndex > -1) {
                const translate3dEndIndex = transformValue.indexOf(')', translate3dIndex)
                transformValue = `${transformValue.slice(0, translate3dIndex)} ${transformValue.slice(translate3dEndIndex + 1)}`
            }

            transformValue += ` translate3d(0px, ${pos}px, 0px)`

            el.style.transform = transformValue

        }    
    
    });

}
const parallaxElements = document.querySelectorAll(`[data-simmons-parallax]`)
if (parallaxElements && Array.from(parallaxElements).length) handleParallaxElements(parallaxElements)

function isElementInViewport (el) {

    // Special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
}

function getSkittlesSectionBgColor(sectionId) {
    if (sectionId.includes('sweet-design')) {
        return '#FEF0DB'
    } else if (sectionId.includes('product-specs')) {
        return '#F8C2ED'
    } else if (sectionId.includes('sd-footer')) {
        return '#FDE4DF'
    } else {
        return '#E3F4FF'
    }
}

function getTheMostVisibleElementInViewport(elements) {
    const windowHeight = window.innerHeight
    let theMostVisibleElement = elements[0]
    let theMostVisibleElementRatio = 0
    for (const el of elements) {
        const { y, height } = el.getBoundingClientRect()
        const visiblePartHeight = windowHeight - y
        const visibilityRatio = visiblePartHeight / height
        if (visibilityRatio > .3 && height + y > 0) {
            theMostVisibleElementRatio = visibilityRatio
            theMostVisibleElement = el
            el.dataset.isInView = 'true'
        } else {
            el.dataset.isInView = 'false'
        }
    }
    return theMostVisibleElement
}

function changePageBgColorDependingOnVisibleSection(sections) {
    const currentSection = getTheMostVisibleElementInViewport(sections)
    const bgColor = getSkittlesSectionBgColor(currentSection.id || '')
    document.querySelector('body').style.backgroundColor = bgColor
}

function handleShopifySectionsBg(sections) {

    changePageBgColorDependingOnVisibleSection(sections)
    window.addEventListener('scroll', () => {
        changePageBgColorDependingOnVisibleSection(sections)
    })

}
const skittlesPageSections = document.querySelectorAll(`.shopify-section[id*="skittles"], .colorized-section`)
if (skittlesPageSections && Array.from(skittlesPageSections).length) handleShopifySectionsBg(Array.from(skittlesPageSections))

async function createBlueshifyIdentifyEvent(params) {
    await blueshift.identify(params)
    // await blueshift.track('skittles', params)
}

async function handleSkittlesFormSubmission(form) {
    
    const data = new FormData(form);
    const dataJSON = Object.fromEntries(data.entries());
    await createBlueshifyIdentifyEvent(dataJSON)

}

const skittlesForms = document.querySelectorAll('.skittles-form')
skittlesForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
        e.preventDefault()
        try {
            skittlesForms.forEach(form => {
                form.dataset.hasFailed = 'false'
                form.dataset.hasSucceed = 'false'
                form.dataset.isProcessing = 'true'
            })
            
            await handleSkittlesFormSubmission(form)

            skittlesForms.forEach(form => {
                form.dataset.hasSucceed = 'true'
            })
        } catch (ex) {
            console.error(ex)
            skittlesForms.forEach(form => {
                form.dataset.hasFailed = 'true'
                form.dataset.hasSucceed = 'false'
            })
        } finally {
            skittlesForms.forEach(form => {
                form.dataset.isProcessing = 'false'
            })
        }
    })
})

function triggerClickOn(selector) {
    document.querySelector(selector).click()
}

function handleProductDetails() {

    const pdAccordionItems = document.querySelectorAll('.product-single__media-group-wrapper [data-accordion-item]')
    const isMobile = window.innerWidth < 640
    if (isMobile) {
        pdAccordionItems.forEach(ai => {
            const content = ai.querySelector('.accordion-content')
            ai.classList.remove('is-active')
            content.style.display = 'none'
        })
    }

}
handleProductDetails()

const warrantyBlockButtons = document.querySelectorAll('.warranty-block__button')
warrantyBlockButtons.forEach(btn => {
    const warrantyCopy = btn.parentElement.querySelector('.warranty-block__copy')
    btn.addEventListener('click', () => {
        const warrantyCopyClone = warrantyCopy.cloneNode(true)
        warrantyCopyClone.removeAttribute('hidden')
        warrantyCopyClone.classList.add('warranty-block__copy-clone')
        warrantyCopyClone.querySelector('.warranty-block__close').addEventListener('click', () => {
            warrantyCopyClone.classList.add('warranty-block__copy--closing')
            setTimeout(() => {
                warrantyCopyClone.parentNode.removeChild(warrantyCopyClone)
                document.body.classList.remove('warranty-block--visible')
            }, 300);
        })
        document.body.classList.add('warranty-block--visible')
        document.body.prepend(warrantyCopyClone)
        console.log({ warrantyCopy, warrantyCopyClone })
    });
})